<template>
    <div class="noCheck"
      v-loading="showLoad"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" >
      <div class="no" @load="iframeLoad"></div>
    </div>   
</template>

<script>
export default {
  name: "unitInformation",
  data() {
    return {
      showLoad: true,
      show: false
    };
  },
  methods: {
    iframeLoad() {
      setTimeout(() => {
        this.showLoad = false;
        document.querySelector(".no").innerHTML = "没有浏览权限";
      }, 1000);
    }
  },
  mounted() {
    this.iframeLoad();
  }
};
</script>

<style>
.nocheck {
  height: 100%;
}
.no {
  width: 100%;
  height: 100vh;
  font-size: 16px;
  color: #666;
  display: block;
  margin: 8px;
}
</style>
